import Navbar from "../../components/Navbar";
import "../faq/css/faq.css"
import "./css/thingstodo.css"
import ThingsToDoEntries from "../../data/ThingsToDo";
import Footer from "../../components/Footer";

const ThingsToDo = () => {
    return (
        <main>
            <Navbar/>

            <div className="container faq__container">

                <h1 className="text-cursive faq__header">Things To Do</h1>

                <div className="faq__content">
                    {
                        ThingsToDoEntries.map((entry) => {
                            return (
                                <div key={entry.id} className="faq__entry">
                                    <h3 className="faq__title">{entry.title.toUpperCase()}</h3>
                                    {entry.address && <p className="todo__address">{entry.address}</p>}
                                    <p className="faq__text">{entry.content}</p>
                                    {entry.link && (
                                        <a className="todo__btn" href={entry.link} target="_blank" rel="noreferrer">
                                            {entry.linkLabel ?? "Learn More"}
                                        </a>
                                    )}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <Footer/>
        </main>
    );
};

export default ThingsToDo;
